import { categories } from "@/mocks/hotData";

const toneStyles = {
  primary: {
    bubble: "bg-primary-100 text-primary-700",
    tag: "bg-primary-50 text-primary-700 border border-primary-200",
  },
  accent: {
    bubble: "bg-accent-100 text-accent-700",
    tag: "bg-accent-50 text-accent-700 border border-accent-200",
  },
  secondary: {
    bubble: "bg-secondary-100 text-secondary-800",
    tag: "bg-secondary-50 text-secondary-800 border border-secondary-200",
  },
};

export default function CategoryRank() {
  return (
    <section id="category" className="mx-auto max-w-[1200px] scroll-mt-24 px-4 py-16 md:px-6 md:py-20">
      <div className="text-center">
        <span className="inline-flex items-center gap-2 rounded-full bg-background-100 px-3 py-1 text-xs font-medium text-foreground-700">
          <i className="ri-apps-2-line text-accent-600"></i>
          分类热榜
        </span>
        <h2 className="mt-4 font-heading text-2xl font-black text-foreground-950 md:text-3xl">
          想追哪块瓜，<span className="text-primary-600">按兴趣直达</span>
        </h2>
        <p className="mx-auto mt-3 max-w-xl text-sm text-foreground-600">
          六大兴趣分类，每个分类展示当前最热话题，追更一目了然。
        </p>
      </div>

      <div className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {categories.map((c) => {
          const tone = toneStyles[c.tone];
          return (
            <a
              key={c.name}
              href="#topics"
              className="group flex flex-col rounded-2xl border border-background-200 bg-background-50 p-5 transition-all hover:-translate-y-1 hover:border-primary-200"
            >
              <div className="flex items-start justify-between">
                <span className={`flex h-12 w-12 items-center justify-center rounded-xl text-2xl ${tone.bubble}`}>
                  <i className={c.icon}></i>
                </span>
                <span className="text-xs text-foreground-400">
                  <b className="text-lg font-black text-foreground-800">{c.count}</b> 条热讯
                </span>
              </div>
              <h3 className="mt-4 font-heading text-lg font-bold text-foreground-950">{c.name}</h3>
              <p className="mt-1 flex-1 text-sm text-foreground-600">{c.blurb}</p>
              <div className="mt-4 flex items-center justify-between">
                <span className={`flex items-center gap-1 whitespace-nowrap rounded-full px-3 py-1 text-xs font-medium ${tone.tag}`}>
                  <i className="ri-fire-fill text-primary-500"></i>
                  {c.top}
                </span>
                <span className="flex h-8 w-8 items-center justify-center rounded-full bg-background-100 text-foreground-600 transition-all group-hover:bg-primary-500 group-hover:text-background-50">
                  <i className="ri-arrow-right-line"></i>
                </span>
              </div>
            </a>
          );
        })}
      </div>
    </section>
  );
}